import { lazy } from 'react'
import { STEPS_ROUTES } from '../constants'

const IdentityData = lazy(() => import('../components/Stepper/IdentityData'))
const AccountType = lazy(() => import('../components/Stepper/AccountType'))
const RegistrationData = lazy(
  () => import('../components/Stepper/RegistrationData'),
)
const ChooseValidation = lazy(
  () => import('../components/Stepper/ChooseValidation'),
)
const CodeValidation = lazy(
  () => import('../components/Stepper/CodeValidation'),
)
const IdentificationCode = lazy(
  () => import('../components/Stepper/Identifier'),
)

const CreatePassword = lazy(
  () => import('../components/Stepper/CreatePassword'),
)
const Clinic = lazy(() => import('../components/Stepper/Clinic'))

export const getComponents = (name: string): React.ReactNode => {
  return {
    [STEPS_ROUTES.CPF]: <IdentityData />,
    [STEPS_ROUTES.ACCOUNT_TYPE]: <AccountType />,
    [STEPS_ROUTES.ACCOUNT]: <AccountType />,
    [STEPS_ROUTES.REGISTRATION_DATA]: <RegistrationData />,
    [STEPS_ROUTES.CHOOSE_VALIDATION]: <ChooseValidation />,
    [STEPS_ROUTES.CODE_VALIDATION_SMS]: (
      <CodeValidation screen="resendCodeSms" />
    ),
    [STEPS_ROUTES.CODE_VALIDATION_MAIL]: (
      <CodeValidation screen="resendCodeEmail" />
    ),
    [STEPS_ROUTES.HEALTH_PLAN]: <Clinic />,
    [STEPS_ROUTES.CORPORATE_BENEFIT]: <Clinic />,
    [STEPS_ROUTES.CORPORATE_BENEFIT_IDENTIFIER]: <IdentificationCode />,
    [STEPS_ROUTES.HEALTH_PLAN_IDENTIFIER]: <IdentificationCode />,
    [STEPS_ROUTES.WHITELABEL_IDENTIFIER]: <IdentificationCode />,
    [STEPS_ROUTES.SAAS_IDENTIFIER]: <IdentificationCode />,
    [STEPS_ROUTES.DOCPASS_IDENTIFIER]: <IdentificationCode />,
    [STEPS_ROUTES.REDE_CONEXA_IDENTIFIER]: <IdentificationCode />,
    [STEPS_ROUTES.CREATE_PASSWORD]: <CreatePassword />,
  }[name]
}
